import CharmsInfoSchema from '../schema/CharmsInfoSchema';
import charmsInfoStore from '../store';
import { select } from 'satcheljs/lib/legacy';

export interface GetCalendarCharmsInfo {
    charmStore: CharmsInfoSchema;
}

export let areDefaultCharmsAvailable = select({
    charmStore: () => charmsInfoStore,
})(function areDefaultCharmsAvailable(state?: GetCalendarCharmsInfo): boolean {
    let defaultSetAvailable = false;
    if (state != null && state.charmStore != null && state.charmStore.charmInfoMap != null) {
        state.charmStore.charmInfoMap.forEach(charminfo => {
            if (charminfo.IsInDefaultSet == true) {
                defaultSetAvailable = true;
            }
        });
    }
    return defaultSetAvailable;
});

export default areDefaultCharmsAvailable;
